import { combineReducers } from 'redux';
import meta from './meta';

const rootReducer = combineReducers({
    meta
});

export default rootReducer;